import { useState, useEffect } from 'react';
import axios from 'axios';
import { Plus, Award } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SkillMaster = () => {
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState({ name: '', code: '' });

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    try {
      const response = await axios.get(`${API}/skills`);
      setSkills(response.data);
    } catch (error) {
      console.error('Error fetching skills:', error);
    }
  };

  const handleCreate = async () => {
    if (!newSkill.name || !newSkill.code) {
      toast.error('Name and code are required');
      return;
    }

    try {
      await axios.post(`${API}/skills`, newSkill);
      toast.success('Skill created successfully');
      setNewSkill({ name: '', code: '' });
      fetchSkills();
    } catch (error) {
      toast.error('Failed to create skill');
    }
  };

  return (
    <div className="space-y-6">
      <Card data-testid="skill-create-card">
        <CardHeader>
          <CardTitle>Add New Skill</CardTitle>
          <CardDescription>Define skill requirements for production operations</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="text-sm font-medium mb-2 block">Skill Name</label>
              <Input
                data-testid="input-skill-name"
                placeholder="CNC Operation"
                value={newSkill.name}
                onChange={(e) => setNewSkill({ ...newSkill, name: e.target.value })}
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-2 block">Code</label>
              <Input
                data-testid="input-skill-code"
                placeholder="CNC-OP"
                value={newSkill.code}
                onChange={(e) => setNewSkill({ ...newSkill, code: e.target.value })}
              />
            </div>
          </div>
          <Button data-testid="create-skill-btn" onClick={handleCreate} className="w-full">
            <Plus className="w-4 h-4 mr-2" />
            Create Skill
          </Button>
        </CardContent>
      </Card>

      <Card data-testid="skill-list-card">
        <CardHeader>
          <CardTitle>
            <div className="flex items-center gap-2">
              <Award className="w-5 h-5" />
              All Skills ({skills.length})
            </div>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Code</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {skills.map((skill) => (
                <TableRow key={skill.id} data-testid={`skill-row-${skill.id}`}>
                  <TableCell className="font-medium">{skill.name}</TableCell>
                  <TableCell>{skill.code}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default SkillMaster;
